import { ICON__magnifying_glass } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_search from '@/locales/keys/i18n_page_search.json';
import { BUTTON__try_app } from '@/pages/_base/buttons/BUTTON__try_app';
import { PLACEHOLDER_bar_line } from '@/pages/_base/views/PLACEHOLDER_bar_line';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { remote_search_create } from '@/state/search/remote_search_create';
import { LOCAL__ui_set_boolean } from '@/state/ui/_base/LOCAL__ui_set_boolean';
import { set_current_search } from '@/utils/utils_client_workspace_child_entity_viewers';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { useTranslation } from 'react-i18next';

export function SButtonStartNewSearch() {
  const dispatch = use_dispatch();
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SEARCH);

  const { is_authorized } = use_slice_user(['is_authorized']);
  const { workspace_current, current_workspace_user } = use_slice_workspace(['workspace_current', 'current_workspace_user']);

  async function onClick() {
    let action_result = await dispatch(remote_search_create(workspace_current._id));

    let search_id = action_result.payload;

    if (typeof search_id != 'string') return;

    await set_current_search(search_id);

    dispatch(LOCAL__ui_set_boolean({ value: false, key: 'page_search_show_history' }));
  }

  if (!is_authorized) return <BUTTON__try_app />; //not authorized
  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_SEARCH_CREATE)) return <PLACEHOLDER_bar_line />;

  return (
    <UI_PRIMITIVE__button className="w-80 min-w-[17.5rem] max-h-9" variant="outline-on-bar" onClick={onClick}>
      <ICON__magnifying_glass className="!w-3 !h-3" />
      {t(i18n_page_search.sidebar.button.start_new_search.title)}
    </UI_PRIMITIVE__button>
  );
}
